<template>
  <div class="facebook-pages">
    <v-container fluid>
      <h1>Facebook Pages</h1>
    <div class="card-curvey" v-for="(page,index) in pagesList">
      <v-layout row wrap>
        <v-flex xs11>
          <h2 class="mb-3">{{page.name}} </h2>
        </v-flex>
        <v-flex xs1 class="text-right">

          <v-switch v-model="page.connected_with_app"></v-switch>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 >
          <label >Facebook App ID</label>
          <v-text-field
            solo
            class="mt-2"
            :disabled="true"
            outline
            v-model="page.app_id"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 >
          <label for="">Facebook App secret</label>
          <v-text-field
            solo
            class="mt-2"
            :disabled="true"
            outline
            type="password"
            v-model="page.app_secret"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>

    <div class="connectors">
      <fb @setFacebookPages="setFacebookPages" :app-id="facebookData.appId" v-if="facebookAutoCred === 'true'" />
      <v-btn
        v-else
        large round flat block
        class="primary--text"
        @click="dialog = true"
      >
        <v-icon>add_circle_outline</v-icon>
        Connect New App
      </v-btn>
    </div>

    <v-dialog v-model="dialog" width="600">
      <v-card class="pa-4">
        <label >Facebook App ID</label>
        <v-text-field
          solo
          class="mt-2"
          outline
          v-model="facebookData.appId"
        ></v-text-field>
        <label for="">Facebook App secret</label>
        <v-text-field
          solo
          class="mt-2"
          outline
          type="password"
          v-model="facebookData.appSecret"
        ></v-text-field>
        <fb @setFacebookPages="setFacebookPages" :app-id="facebookData.appId"/>
      </v-card>
    </v-dialog>
    </v-container>
  </div>

</template>

<script>
  import common from "../../../../utils/common";
  import _ from 'lodash'
  import fb from "./fb";
  export default {
    name: "facebookPages",
    data () {
      return {
        facebookData: {
          appId: '',
          appSecret: '',
          pages: []
        },
        pagesList: [],
        dialog: false
      }
    },
    mounted() {
      if (process.env.VUE_APP_FACEBOOK_AUTO_PUBLISHER_CREDENTIAL === 'true') {
        this.facebookData.appId = process.env.VUE_APP_FACEBOOK_APP_ID
      }
      this.getPages()
    },
    components: {
      fb
    },
    methods: {
      async updateFacebookSelectedPage () {
        await this.$http_session_manager.put(`/bots/${this.$store.state.bot.botId}/apps/facebook`,this.pagesList)
          .then(response=> {
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      },
      async getPages () {
        await this.$http_session_manager.get(`bots/${this.botId}`)
        .then(response=>{
          if (response .data) {
            this.pagesList = response.data.facebook_apps
          }

        })
        .catch(error=>{

        })
      },
      async getFacebookPageImage (page_id) {
        return  this.$http_without_base.get(`https://graph.facebook.com/v8.0/${page_id}/picture?redirect=0`)
      },
      async setFacebookPages(pages) {
        for (let i=0; i<pages.length;i++) {
          pages[i].connected_with_app = false
          pages[i].app_id = this.facebookData.appId
          pages[i].app_secret = this.facebookData.appSecret
          let image = await this.getFacebookPageImage(pages[i].id)
          pages[i].image = image.data.data.url
          pages[i].page_id = pages[i].id
          delete pages[i].category
          delete pages[i].category_list
          delete pages[i].tasks
          delete pages[i].category
          delete  pages[i].id

          // remove duplicated old pages
          if (this.pagesList.length) {
            let duplicatedIndex = this.pagesList.findIndex((page)=>{
              return page.page_id === pages[i].page_id
            })
            if (duplicatedIndex) {
              this.pagesList.splice(duplicatedIndex,1)
            }
          }

        }
        this.pagesList = this.pagesList ? this.pagesList.concat(pages) : pages
        this.dialog = false
      },
    },
    computed: {
      botId() {
        return this.$store.state.bot.botId
      },
      facebookAutoCred () {
        return process.env.VUE_APP_FACEBOOK_AUTO_PUBLISHER_CREDENTIAL
      }
    },
    watch: {
      pagesList: {
        handler(){
          this.updateFacebookSelectedPage()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>

</style>
